import type { SharedProps } from '@bonniernews/dn-design-system-web/assets/types/shared-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'

import { DirektCircle } from '@bonniernews/dn-design-system-web/components/direkt-circle/direkt-circle.tsx'

export interface DirektHeaderProps extends SharedProps {
  title: string
  subtitle?: string
  pretitle?: string
  isAnimated?: boolean
  renderAsH2?: boolean
}

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/teaser-onsite](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/direkt-header)
 * - Storybook: [DirektHeader](https://designsystem.dn.se/?path=/docs/section-direkt-header--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/direkt-header/direkt-header.scss'`
 */
export const DirektHeader = ({
  classNames,
  attributes = {},
  title,
  subtitle,
  pretitle = 'Direkt',
  isAnimated = true,
  renderAsH2 = false,
}: DirektHeaderProps) => {
  const componentClassName = 'ds-direkt-header'
  const classes = formatClassString([componentClassName, classNames])

  return (
    <header className={classes} {...attributes}>
      <p className={`${componentClassName}__pre-title`}>
        <span className={`${componentClassName}__circle-wrapper`}>
          <DirektCircle classNames={`${componentClassName}__circle`} isAnimated={isAnimated} />
        </span>
        {pretitle}
      </p>
      {renderAsH2 ? (
        <h2 className={`${componentClassName}__title`}>{title}</h2>
      ) : (
        <h1 className={`${componentClassName}__title`}>{title}</h1>
      )}
      {subtitle &&
        (renderAsH2 ? (
          <h3 className={`${componentClassName}__sub-title`}>{subtitle}</h3>
        ) : (
          <h2 className={`${componentClassName}__sub-title`}>{subtitle}</h2>
        ))}
    </header>
  )
}
